var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBackIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.50098 10.75H19.501C19.6999 10.75 19.8907 10.829 20.0313 10.9697C20.172 11.1103 20.251 11.3011 20.251 11.5C20.251 11.6989 20.172 11.8897 20.0313 12.0303C19.8907 12.171 19.6999 12.25 19.501 12.25H4.50098C4.30206 12.25 4.1113 12.171 3.97065 12.0303C3.82999 11.8897 3.75098 11.6989 3.75098 11.5C3.75098 11.3011 3.82999 11.1103 3.97065 10.9697C4.1113 10.829 4.30206 10.75 4.50098 10.75Z",
    fill: "#0B0A0A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.81184 11.5009L11.0323 17.7199C11.1732 17.8608 11.2523 18.0518 11.2523 18.2509C11.2523 18.4501 11.1732 18.6411 11.0323 18.7819C10.8915 18.9228 10.7005 19.0019 10.5013 19.0019C10.3022 19.0019 10.1112 18.9228 9.97034 18.7819L3.22034 12.0319C3.1505 11.9623 3.09508 11.8795 3.05727 11.7884C3.01946 11.6973 3 11.5996 3 11.5009C3 11.4023 3.01946 11.3046 3.05727 11.2135C3.09508 11.1224 3.1505 11.0396 3.22034 10.9699L9.97034 4.21995C10.1112 4.07912 10.3022 4 10.5013 4C10.7005 4 10.8915 4.07912 11.0323 4.21995C11.1732 4.36078 11.2523 4.55178 11.2523 4.75095C11.2523 4.95011 11.1732 5.14112 11.0323 5.28195L4.81184 11.5009Z",
    fill: "#0B0A0A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackIcon);
export default __webpack_public_path__ + "static/media/back-icon.d4cfe0c389990c8ecfd0abe7a282d660.svg";
export { ForwardRef as ReactComponent };